import { FunctionComponent } from "react";
import { Routes, Route } from "react-router-dom";
import ConsultantRegistration from "src/pages/authentication/ConsultantRegistration";
import ConfirmAccount from "src/pages/authentication/ConfirmAccount";
import Login from "src/pages/authentication/Login";
import SubscriberRegistration from "src/pages/authentication/SubscriberRegistration";
import ForgotPassword from "src/pages/authentication/ForgotPassword";
import ConfirmForgotPassword from "src/pages/authentication/ConfirmForgotPassword";
import ClientOnboardingForms from "src/pages/authentication/ClientOnboardingForms";
import PayAndBook from "src/pages/dashboard/NEATT/ActionableItems/PayAndBook";
import Subscribe from "src/pages/authentication/Subscribe";
import InitialMAP from "src/pages/authentication/InitialMAP";

const AuthRoutes: FunctionComponent = () => (
  <Routes>
    <Route path="/" element={<></>} />
    <Route path="/login" element={<Login />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/confirm-forgot-password" element={<ConfirmForgotPassword />} />
    <Route
      path="/subscriber-registration"
      element={<SubscriberRegistration />}
    />
    <Route path="/client-registration" element={<ClientOnboardingForms />} />
    <Route
      path="/consultant-onboarding-document"
      element={<ConsultantRegistration />}
    />
    <Route
      path="/client-vcc-registration"
      element={<ClientOnboardingForms skipPayment={true} />}
    />

    <Route
      path="/subscription-payment"
      element={<Subscribe />}
    />

    <Route
      path="/first-pull"
      element={<InitialMAP />}
    />
  </Routes>
);

export default AuthRoutes;
